import React, {Component} from "react";
import {Button, DatePicker, Form, Input, Select, notification} from "antd";
import moment from 'moment';

import {getGameList} from "../../../modules/team/action";
import connect from "react-redux/es/connect/connect";
import {injectIntl} from "react-intl-context";
import { getLadderBrandList } from "../../../modules/brand/action";
import {map} from 'lodash/fp';
const dateFormat = 'YYYY-MM-DD';
const FormItem = Form.Item;
const Option = Select.Option;
const {RangePicker} = DatePicker;


const openNotification = placement => {
    notification.error({
        message: `${placement}`,
        // description:
        //     'This is the content of the notification. This is the content of the notification. This is the content of the notification.',
        // placement,
    });
};

class TrainingTemplateFilter extends Component {

    constructor(props) {
        super(props);
        this.state = {
            
        }
        this.handleSubmit = this.handleSubmit.bind(this);

    }

    componentWillMount() {
        this.getLadderBrandList();
        this.getGameList();
    }

    getLadderBrandList = () => {
        let { getLadderBrandList } = this.props;
        getLadderBrandList({page: 1, size: 100000});
    }

    getGameList = () => {
        let { getGameList } = this.props;
        getGameList();
    }

    handleSubmit(e) {
        let { onCommit } = this.props;
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                onCommit(values);
            }
        });
    }

    render() {
        const {getFieldDecorator} = this.props.form;
        let {ladderBrands, games} = this.props;
        return (
            <Form onSubmit={this.handleSubmit} layout="inline" style={{width: '100%'}}>
                <FormItem label="品牌名称">
                    {getFieldDecorator('brandId', {
                            initialValue: ""
                        }
                    )(
                        <Select style={{minWidth: 250}}>
                            <Option value="">全部</Option>
                            {ladderBrands.data && ladderBrands.data.length > 0 && ladderBrands.data.map(item => {
                                let gameList = games.filter((game) => game.code == item.game);
                                return (
                                    <Option
                                        value={item.id}>{(gameList.length > 0 ? gameList[0].gameName + '-' : '') + item.name}</Option>
                                )
                            })}
                        </Select>
                    )}
                </FormItem>

                <FormItem>
                    <Button type="primary" htmlType="submit" style={{width: '100%'}}>
                        查询
                    </Button>
                </FormItem>
            </Form>
        );
    }
}



const mapStateToProps = (state) => {
    return {
        ...state.viewTraining,
        ...state.Team,
        ...state.Brand
    }
};
const mapDispatchToProps = ({
    getGameList,
    getLadderBrandList
});
export default connect(
    mapStateToProps, mapDispatchToProps,
)(injectIntl(Form.create()(TrainingTemplateFilter)));